import adminApi from "./adminApi";


export async function getAlgorithmPresets() {

    const { data } =
        await adminApi.get("/algorithm/presets");

    return data.presets;
}


export async function getAlgorithmPreset(id) {

    const { data } =
        await adminApi.get(`/algorithm/presets/${id}`);

    return data;
}


export async function createAlgorithmPreset(payload) {

    const { data } =
        await adminApi.post(
            "/algorithm/presets",
            payload
        );

    return data;
}


export async function updateAlgorithmPreset(id, payload) {

    const { data } =
        await adminApi.put(
            `/algorithm/presets/${id}`,
            payload
        );

    return data;
}


export async function activateAlgorithmPreset(id) {

    const { data } =
        await adminApi.post(
            `/algorithm/presets/${id}/activate`
        );

    return data;
}


export async function deleteAlgorithmPreset(id) {

    const { data } =
        await adminApi.delete(
            `/algorithm/presets/${id}`
        );

    return data;
}

export async function getAvailableModules() {

    const { data } =
        await adminApi.get("/algorithm/modules");

    return data.modules;
}

export async function getAvailableAlgorithmModules(){

    const { data } =
        await adminApi.get(
            "/algorithm/modules"
        );

    return data.modules;

}


export async function addAlgorithmModule(
    presetId,
    module_name
) {

    const { data } =
        await adminApi.post(
            `/algorithm/presets/${presetId}/modules`,
            {
                module_name
            }
        );

    return data;
}

export async function deleteAlgorithmModule(
    presetId,
    moduleId
){

    const { data } =
        await adminApi.delete(
            `/algorithm/presets/${presetId}/modules/${moduleId}`
        );

    return data;
}

export async function getAvailableFilters(){

    const {data} =
        await adminApi.get(
            "/algorithm/available-filters"
        );

    return data.filters;
}